import { Fancybox } from '@fancyapps/ui'; // eslint-disable-line

export default ($) => {
	let _filterTrigger = document.getElementById('trigger-filter');

	if (!_filterTrigger)
		return;

	let _search					= document.getElementById('db-search-field');
	let _dbResults				= $('#db-results-count');
	let _dbListings				= $('.js-db-listing');
	let _sectHeadings			= $('.db-section-heading');
	let alphaFilter				= $('select[name=alpha]');
	let subjectFilter			= $('select[name=subject]');
	let _fancybox;

	let _foundResult			= 0;
	let _foundCount				= 1;

	if (_search)
		searchDBFilter();

	DBSelectFilter(alphaFilter);
	DBSelectFilter(subjectFilter);

	_dbListings.on('click', function () {
		let _this = $(this);
	});

	function searchDBFilter() {
		_search.addEventListener('keyup', function () {
			let filterRegex = new RegExp('\\b' + this.value, 'gi');
			_foundResult = 0;
			_foundCount = 1;
			_sectHeadings.addClass('hidden');

			let dbLists = document.getElementsByClassName('js-db-listing');
			
			for (let dl=0; dl<dbLists.length; dl++) {
				let itemTitle = dbLists[dl].getElementsByClassName('lightweight-accordion-title')[0].innerText;
				let itemDescription = dbLists[dl].getElementsByClassName('lightweight-accordion-body')[0].innerText;
				let titleAlpha = Array.from(itemTitle)[0].toUpperCase();
				let letterHeading = document.getElementById(titleAlpha);
				let found = itemTitle.match(filterRegex);
				
				if (!found) {
					found = itemDescription.match(filterRegex);
				}
				
				if (found) {
					_foundResult++;
					_foundCount++;
					if (letterHeading.classList.contains('hidden')) {
						letterHeading.classList.remove('hidden');
					}
				}
				
				dbLists[dl].classList.toggle('hidden', !found);
			}

			if (!_foundResult) {
				_dbResults.text('No Results.');
			} else {
				let resText = ' Total Result';
				let suffix = _foundResult > 1 ? 's' : '';
				resText = resText + suffix;
				_dbResults.text(_foundResult + resText);
			}
		});
	}

	function DBSelectFilter(select) {
		select.on('change', function () {
			let alphaVal = alphaFilter.val();
			let subjVal = subjectFilter.val();
			let subjValRegEx = new RegExp('\\b' + subjVal + '\\b', 'gi');
			_foundResult = 0;
			_foundCount = 1;

			if (!alphaVal && !subjVal) {
				_dbListings.removeClass('hidden');
				_sectHeadings.removeClass('hidden');
			} else {
				if (subjVal) {
					_sectHeadings.addClass('hidden');
				}
				let dbLists = document.getElementsByClassName('js-db-listing');
				
				for (let dl=0; dl<dbLists.length; dl++) {
					let check = false;
					let itemTitle = dbLists[dl].getElementsByClassName('lightweight-accordion-title')[0].innerText;
					let itemDescription = dbLists[dl].getElementsByClassName('lightweight-accordion-body')[0].innerText;
					let titleAlpha = Array.from(itemTitle)[0].toUpperCase();
					let letterHeading = document.getElementById(titleAlpha);
					
					if (!alphaVal && (itemTitle.match(subjValRegEx) || itemDescription.match(subjValRegEx))) {
						check = true;
						if (letterHeading.classList.contains('hidden')) {
							letterHeading.classList.remove('hidden');
						}
					} else if (!subjVal && itemTitle.startsWith(alphaVal)) {
						check = true;
					}
					
					if (!check && alphaVal && subjVal && itemTitle.startsWith(alphaVal) && (itemTitle.match(subjValRegEx) || itemDescription.match(subjValRegEx))) {
						check = true;
					}
					
					if (!check) {
						$(dbLists[dl]).addClass('hidden');
					} else {
						$(dbLists[dl]).removeClass('hidden');
						_foundResult++;
						_foundCount++;
					}
					
					if (!_foundResult) {
						_dbResults.text('No Results.');
					} else {
						let resText = ' Total Result';
						let suffix = _foundResult > 1 ? 's' : '';
						resText = resText + suffix;
						_dbResults.text(_foundResult + resText);
					}
				}
				
				if (alphaVal) {
					for (let h=0; h<_sectHeadings.length; h++) {
						
						if (_sectHeadings[h].getAttribute('id') !== alphaVal) {
							$(_sectHeadings[h]).addClass('hidden');
						} else {
							$(_sectHeadings[h]).removeClass('hidden');
						}
					}
				}
			}
		});
	}
};